<template>
  <b-card>
    <b-form @submit.prevent="handleSubmit" autocomplete="off">
      <b-row>
        <b-col md="6">
          <b-form-group label="Stage Title *" label-for="stage_title">
            <b-form-input
              id="stage_title"
              v-model.trim="form.title"
              required
              placeholder="Enter stage title"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Alias" label-for="alias">
            <b-form-input
              id="alias"
              :value="slugify(form.title || '')"
              :placeholder="form.title ? slugify(form.title) : 'Auto generated from title'"
              disabled
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Description" label-for="description">
            <b-form-textarea
              id="description"
              v-model="form.description"
              rows="6"
              placeholder="Write description here..."
            />
          </b-form-group>
        </b-col>
      </b-row>

      <div class="d-flex justify-content-end">
        <b-button
          variant="outline-secondary"
          class="mr-2"
          @click="$emit('close')"
          >Close</b-button
        >
        <b-button type="submit" variant="primary">Submit</b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
import { busdevActions } from '@/src/Utils/helper'

export default {
  name: 'FormAddProjectStage',
  props: {
    selectedData: {
      type: Object,
      default: null,
    },
    kanbanData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        title: '',
        alias: '',
        is_running: false,
        is_spal: false,
        is_deny: false,
        is_end_stage: false,
        description: '',
      },
      isEdit: false,
      aliasLocked: true, // keep alias input disabled (as in the mockup)
    }
  },
  watch: {
    'form.title'(val) {
      if (!this.isEdit) {
        this.form.alias = this.slugify(val)
      }
    },
  },
  mounted() {
    if (this.selectedData) {
      this.isEdit = true
      this.form = {
        title: this.selectedData.title || '',
        alias:
          this.selectedData.alias || this.slugify(this.selectedData.name || ''),
        is_running: !!this.selectedData.is_running,
        is_spal: !!this.selectedData.is_spal,
        is_deny: !!this.selectedData.is_deny,
        is_end_stage: !!this.selectedData.is_end_stage,
        description: this.selectedData.description || '',
      }
    }
  },
  methods: {
    ...busdevActions,
    slugify(text) {
      if (!text) return ''
      return text
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
    },
    async handleSubmit() {
      // Basic required validation
      if (!this.form.title) {
        this.$bvToast &&
          this.$bvToast.toast('Stage Title  is required.', {
            title: 'Validation',
            variant: 'warning',
            solid: true,
          })
        return
      }

      // If editing, update instead of create
      if (this.isEdit && this.selectedData && this.selectedData.id) {
        const payload = {
          id: this.selectedData.id,
          ...this.form,
        }
        const res = await this.updateDetailProjectStage({ data: payload, id: payload.id })
        if (res?.data?.status || res?.status === 'success') {
          this.$swal.fire('Success', 'Project Stage has been updated.', 'success')
          this.$emit('refetch')
          this.$emit('close')
        } else {
          this.$swal.fire('Error', 'Failed to update Project Stage.', 'error')
        }
        return
      }

      // Else create new
      const lastObject = this.kanbanData.slice(-1)[0]
      const payload = {
        ...this.form,
        order: (lastObject?.order ?? 0) + 1,
      }

      const res = await this.createDetailProjectStage({ data: payload })
      if (res?.data?.status || res?.status === 'success') {
        this.$swal.fire('Success', 'Project Stage has been added.', 'success')
        this.$emit('refetch')
        this.$emit('close')
      } else {
        this.$swal.fire('Error', 'Failed to add Project Stage.', 'error')
      }
    },
  },
}
</script>

<style scoped>
/* Subtle spacing similar to the mockup */
.form-text {
  color: #6c757d;
}
</style>
